import React, { useState, useEffect } from "react";
import styled from "styled-components";
import NavFront from "../Front/NavFront";
import NavFornt from "../Front/NavFront";
//import pro from '../../../assets/z1.png'
import Tile from "../Front/Tile";
import FooterNew from "../../layouts/FooterNew";
import { userContext } from "../../../App";
import { auth, db } from "../../../firebase";
import firebase from "../../../firebase";
// import { useState } from "react/cjs/react.development";
import { useHistory } from "react-router";
import user from '../../../assets/user.png';
import PublishIcon from '@material-ui/icons/Publish';
import CancelIcon from '@material-ui/icons/Cancel';
import SimpleModal from './SimpleModal';
import ProfileTile from '../Front/ProfileTile';
import Search from '../Front/Search';
import { makeStyles, withStyles } from "@material-ui/core/styles";
import Footer from "../../layouts/Footer";
import { useMediaQuery } from "@material-ui/core";



const useStyles = makeStyles((theme) => ({
    root: {
      display: 'flex',
      fontFamily: "Rubik",
    //   justifyContent: "center",
    //   alignItems: "center",
    },
    content: {
      marginTop: "85px",
      fontFamily: 'Rubik',
      display: "flex",
      flexDirection: "column",
      width: "100%",
      padding: "50px 24px",
    //   justifyContent: "center",
    alignItems: "center",
    //   '@media (max-width: 575px)': {
        // flexDirection: "column",
        // padding: "50px 15px",
    //   },
      '@media (max-width: 362px)': {
        // marginTop: "90px",
        padding: "50px 12px",
      },
    },
  
    modal: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
    },
    paper: {
      backgroundColor: theme.palette.background.paper,
      boxShadow: theme.shadows[5],
      padding: "20px",
    },
    icon: {
      position: 'absolute', 
      margin: '5px auto', 
      cursor: 'pointer', 
      width: "140px",
      '@media (max-width: 543px)': {
        width: "126.34px",
    }
    }
  }));



const User = ()=>{
    const id=JSON.parse(localStorage.getItem("profileid"))['profileid'];
    const uid=JSON.parse(localStorage.getItem("user"))['uid'];
    const history = useHistory();
    if(localStorage.getItem('allowed')==='0'){
        window.location.href = '/home';
    }
    function tileclick(x){

        localStorage.setItem(
            "postid",
            JSON.stringify({
              postid:x,
             
            })
          );
          history.push(`/folio/${x}`)
    }

    const classes = useStyles();
    const [post, setpost] = useState([]);
    const [name, setname] = useState();
    async function delete_folio(z)
    {
        await db.collection("posts").doc(z).delete();
    }
    const[count,setCount]=useState(0);
    const[read,setRead]=useState(0);
    const[follower,setFollower]=useState(0);
    const [allowEdit, setallowEdit] = useState(false);
    const [removePhoto, setremovePhoto] = useState(false);
    const [profilePhoto, setprofilePhoto] = useState(user);
    const [publishPhoto, setpublishPhoto] = useState(false);
    const [desc, setdesc] =useState("");
    const [imgUrl, setimageUrl] = useState(null);
    const[isfollow,setisfollow]=useState();
    const[followList,setfollowlist]=useState();
    const [searchtext, setsearchtext] = useState('');
    const[searchtype,setsearchtype]=useState([]);
    const [navClick, setnavClick] = useState(false);
    const [allposts, setallposts] = useState([]);
    const [exacttitle, setexacttitle] = useState('');
    const [searchtitle, setsearchtitle] = useState([]);
    const [searchClicked, setsearchClicked] = useState(false);
    const[test,setTest]=useState(false);
    const fetchBlogs = async () => {
        //const id=JSON.parse(localStorage.getItem("profileid"))['profileid'];
            console.log(id);
      const response = db.collection("posts").where("postedBy","==",id );
      const data = await response.onSnapshot((querySnapshot) => {
        const arr=[];
        var c=0;
        var r=0;
        querySnapshot.forEach((doc) => {
            var data=doc.data();
            c=c+1;
            r=r+doc.data().read_Count;
            data={...data,id:doc.id}
    
            arr.push(data);
            
        
        })
        
        setpost(arr);
        setCount(c);
        setRead(r);
      });
        var docRef = db.collection("users").doc(id);
        const data2 = await docRef.onSnapshot((querySnapshot) => {
            var follow=0;var profile_pic;var name,desc;
            follow=querySnapshot.data().follower_Count;
            profile_pic=querySnapshot.data().profilePic;
            name=querySnapshot.data().name;
            desc=querySnapshot.data().description;
           var f_arr=querySnapshot.data().follower;
           setfollowlist(querySnapshot.data().follower);
           if(f_arr.indexOf(uid)>-1)
           {
                setisfollow(true)
           }
           else{
                   setisfollow(false);
           }
            if(profile_pic==="")
            {
                    setprofilePhoto(user);
            }
            else{
                setprofilePhoto(profile_pic)
            }
            setFollower(follow);
            setname(name);
            setdesc(desc);
        });
    }
    useEffect(() => {
      
      
      fetchBlogs();
      
    }, [id]);

    const Tofollow=async()=>{
        let arr=[...followList];
        arr.push(uid);
        await db.collection("users").doc(id).update({follower:arr});
        await db.collection("users").doc(id).update({follower_Count:arr.length});
        setisfollow(true);
    }
    const Tounfollow=async()=>{
        let arr=[...followList];
        arr = arr.filter(e => e !== uid);
        await db.collection("users").doc(id).update({follower:arr});
        await db.collection("users").doc(id).update({follower_Count:arr.length});
        setisfollow(false);
    }

    const remove = () =>{
      
        setremovePhoto(true);
        setprofilePhoto(user);
        setimageCropped(false);
       // setimageCropped(false);
        db.collection("users").doc(uid).update({profilePic:""});
    }

    const Edit = () =>{
        const uid = auth.currentUser.uid;
        setallowEdit(true);
    }

    
    
    const [imageCropped, setimageCropped] = useState(false);
    const [image, setImage] = useState(null);
    const types = ["image/png", "image/jpeg", "image/jpg"];
    const [fileselect, setfileselect] = useState(null);

    var getFileBlob = function (url, cb) {
    var xhr = new XMLHttpRequest();
    xhr.open("GET", url);
    xhr.responseType = "blob";
    xhr.addEventListener('load', function() {
      cb(xhr.response);
    });
    xhr.send();
  };
    const handleChange = (e) => {
        let selectedFile = e.target.files[0];
        setfileselect(URL.createObjectURL(selectedFile));
        if (selectedFile) {
          console.log('a')
          if (types.includes(selectedFile.type)) {
            setImage(selectedFile);
            // const files = firebase.storage();
            // getFileBlob(fileselect, blob =>{
            //     firebase.storage().ref(`/folios/${uid}`).put(blob).then(snap => {
            //       snap.ref.getDownloadURL().then((url) => {
            //         setimageUrl(url);
            //         db.collection("users").doc(uid).update({profilePic:url});
            //       });
            //     })
            // })
    // files
    //   .ref(`/users/${uid}`)
    //   .put(selectedFile)
    //   .then((snap) => {
    //     console.log(snap);
    //     snap.ref.getDownloadURL().then((url) => {
    //      console.log(url);
    //      db.collection("users").doc(uid).update({profilePic:url});
    //       setimageUrl(url);
    //     });
    // });
          } else {
            console.log('b')
            setImage(null);
          }
        }
      };
      useEffect(()=>{
        if(!fileselect)
          setTest(false);
        else
          setTest(!test);
      
      },[fileselect])
      
  const save=async()=>{
    setallowEdit(false);
    setremovePhoto(false);
    console.log(desc);
    console.log(name);
    if(imageCropped){
        const uid = auth.currentUser.uid;
        await getFileBlob(fileselect, blob =>{
        firebase.storage().ref(`/users/${uid}`).put(blob).then(snap => {
            snap.ref.getDownloadURL().then((url) => {
            setimageUrl(url);
            db.collection("users").doc(uid).update({profilePic:url});
            });
        })
        })
      
    }
    
    await db.collection("users").doc(uid).update({name:name});
    await db.collection("users").doc(uid).update({description:desc});
    const data=await db.collection("posts").where("postedBy","==",uid).get();
 await data.docs.forEach(item=>{
     db.collection("posts").doc(item.id).update({name:name});
      })
   
  }
  const mediaMatch = window.matchMedia('(max-width: 815px)');
  const [matches, setMatches] = useState(mediaMatch.matches);

  useEffect(() => {
    const handler = e => setMatches(e.matches);
    mediaMatch.addListener(handler);
    return () => mediaMatch.removeListener(handler);
  });

  const isMobile = useMediaQuery((theme) => theme.breakpoints.up("xs"));

    return(
        <>
        <div>
          {/* Navbar */}
          <NavFront
            setnavClick={setnavClick}
            setsearchClicked={setsearchClicked}
            setexacttitle={setexacttitle}
            searchtitle={searchtitle}
            setsearchtitle={setsearchtitle}
            searchtext={searchtext}
            setsearchtext={setsearchtext}
            setsearchtype={setsearchtype}
          />
          {!searchClicked && searchtext !== "" ? (
            <Search
              exacttitle={exacttitle}
              searchtitle={searchtitle}
              setsearchClicked={setsearchClicked}
              searchtype={searchtype}
              searchtext={searchtext}
            />
          ) : null}
        </div>
  
        <div className={classes.root}
          style={{ minHeight: "100vh" }}
        >
          <main className={classes.content}>
     
        <Detail>
            <input
            type="file"
            id='input-file'
            name="image"
            accept="image/x-png,image/gif,image/jpeg,image/jpg"
            onChange={handleChange}
            style={{visibility: 'hidden', position: 'absolute'}}
            />
            {uid===id?
            <SideContent>
            {imageCropped ? <Image style={{ backgroundImage: `url(${fileselect})`}}
            // profilePhoto={fileselect}
            /> : <Image style={{ backgroundImage: `url(${profilePhoto})`}}
            //  profilePhoto={profilePhoto}
             />}
                
                {allowEdit ? 
                    profilePhoto!==user ? removePhoto ? 
                
                <Label fileselect={fileselect} for='input-file'>
                        <PublishIcon className={classes.icon} onClick={(e) => setpublishPhoto(true)} color='primary'/>
                </Label>
                
                : <CancelIcon color='secondary' className={classes.icon} onClick={remove}/> 

                : <Label fileselect={fileselect} for='input-file'>
                        <PublishIcon onClick={(e) => setpublishPhoto(true)} color='primary' 
                        className={classes.icon}/>
                </Label> 
                : null}

{/* {removePhoto ? 
                
                (
                  <Label fileselect={fileselect} for='input-file'>
                        <PublishIcon onClick={(e) => setpublishPhoto(true)} color='primary' 
                        style={{position: 'absolute', margin: '5px auto', cursor: 'pointer', width: "140px"}}/>
                </Label>
                
                ): null} */}

                {/* {allowEdit ? (
                      
                      profilePhoto!==user ? (
                    <>
                      <CancelIcon color='secondary' style={{position: 'absolute', margin: '5px auto', cursor: 'pointer', width: "140px"}} onClick={remove}/> 

                      {removePhoto ? (
                        
                          <Label fileselect={fileselect} for='input-file'>
                                <PublishIcon onClick={(e) => setpublishPhoto(true)} color='primary' 
                                style={{position: 'absolute', margin: '5px auto', cursor: 'pointer', width: "140px"}}/>
                          </Label>
                        
                        ) : null}
                
                    </>
                    
                    )
                    : (
                      <>
                          <Label fileselect={fileselect} for='input-file'>
                            <PublishIcon onClick={(e) => setpublishPhoto(true)} color='primary' 
                            style={{position: 'absolute', margin: '5px auto', cursor: 'pointer', width: "140px"}}/>
                          </Label>
                        </>
                      ) 
                      
                    )
                
                : null} */}

                {/* <Button>Following</Button> */}

                {allowEdit ? <Button onClick={save}>Save</Button> : <Button onClick={Edit}>Edit</Button>}
                
                {publishPhoto & test===true ? 

                    <SimpleModal 
                    fileselect={fileselect} 
                    setfileselect={setfileselect} 
                    imageCropped={imageCropped} 
                    setimageCropped={setimageCropped}
                    width={!isMobile ? (294.94):(375.61)} 
                    height={!isMobile ? (345.5):(440)}
                    setTest={setTest} /> : null}
            
            </SideContent>:
            
            <SideContent>
                <Image style={{ backgroundImage: `url(${profilePhoto})` }}/> 
                { isfollow===true ? 
                <Button onClick={Tounfollow}>Following</Button>
                :<Button onClick={Tofollow}>Follow</Button>}
            </SideContent>}
            
            <Bio>
                <Name maxLength='40' minLength='1' value={name} disabled={!allowEdit} onChange={e=>setname(e.target.value)}/>
                <Lines maxLength='237' minLength='1' rows='5' disabled={!allowEdit} value={desc} onChange={e=>setdesc(e.target.value)}></Lines>
                <Tabs>
                    <Tab>Folios <span >{count}</span></Tab>
                    <Tab>Reads <span >{read}</span></Tab>
                    <Tab>Followers <span >{follower}</span></Tab>
                </Tabs>
            </Bio>
        </Detail>
        <Hr />

        <TileSec 
        // style={{width: `calc(173px * ${count})`}}
        style={{ width: matches ? (`calc(165px * ${count})`) : (`calc(173px * ${count})`) }}
        >
        {post &&
              post.map(p=> {
                return( 
                <>
                {uid===id?
                <ProfileTile Title={p.title} Image={p.img_url} id={p.id} onclick={tileclick} read={p.read_Count} deleted={delete_folio}/>:<Tile Title={p.title} Image={p.img_url} id={p.id} onclick={tileclick} Name={p.name} read={p.read_Count} />}
                </>
                );
              })}
        </TileSec>


        {/* <hr style={{
            height:"0.45vh",
            border:"none",
            width: "107.4vw",
            background:"#5DB0D8",
        }}></hr>
        <Bottom>
            <div className="container">
            <div class="row">
        
        
            {post &&
              post.map(p=> {
                return( <div className="col-xs-12 col-sm-12 col-md-6 col-lg-2">{uid===id?<ProfileTile Title={p.title} Image={p.img_url} id={p.id} onclick={tileclick} read={p.read_Count} deleted={delete_folio}/>:<Tile Title={p.title} Image={p.img_url} id={p.id}  onclick={tileclick} Name={p.name} read={p.read_Count}/>}</div>);
              })} 
          </div>
            </div>
      
        </Bottom> */}

          </main>
        </div>
        <hr style={{ margin: 0, height: "0.8px" }} />
        <Footer />
      </>
    )
}

export default User;

const Detail = styled.div`
display:flex;
flex-direction: row;
`

const SideContent = styled.div`
display:flex;
flex-direction:column;
margin: 0 10px;
justify-content:space-between;
@media (max-width: 543px){
margin: 0 5px;
};
`

const Image = styled.div`
width: 140px;
height: 164px;
// margin-bottom: 20px;
border-radius:20px;
background-position: center;
background-repeat: no-repeat;
background-size: cover;
@media (max-width: 543px){
    width: 126.34px;
    height: 148px;
};
@media (max-width: 395px){
    width: 110px;
    height: 128.86px;
};
`

const Button = styled.button`
width: 140px;
height: 40px;
border: none;
color: white;
background: #5db0d8;
border-radius: 18px;
font-family: Rubik;
font-style: normal;
font-weight: normal;
font-size: 19px;
text-align: center;
@media (max-width: 543px){
    font-size: 16px;
    width: 126.34px;
    height: 35px;
};

@media (max-width: 395px){
  width: 110px;
  // height: 128.86px;
};

`

const Bio = styled.div`
display:flex;
flex-direction:column;
margin: 0 10px;
@media (max-width: 543px){
    margin: 0 5px;
    };
`
const Name= styled.input`
// margin-bottom: 10px;
text-overflow: ellipsis;
font-family: Rubik;
font-style: normal;
font-weight: normal;
font-size: 20px;
color: #000000;
background-color:#fff;
border: 1px solid black;
padding: 0 5px;
// &:focus{
//     border: none;
//     outline: none;
// }
&:disabled{
    
    border: none;
}
&::placeholder{
    color: black;
}

@media (max-width: 543px){
    font-size: 18px;
};

@media (max-width: 400px){
    font-size: 16px;
};


`
const Lines = styled.textarea`
resize: none;
width: 320px;
// height: 190px;
padding: 5px;
color: #000000;
margin-bottom: 20px;
background-color:#fff;
text-align: justify;
border: 1px solid black;
// &:focus{
//     border: none;
//     outline: none;
// }
&:disabled{
   
    border: none;
}
&::placeholder{
    color: black;
}
// overflow: hidden;

@media (max-width: 543px){
    font-size: 14px;
    width: 220px;
};
@media (max-width: 400px){
    font-size: 12px;
    width: 190px;
};

`
const Tabs = styled.div`
    display:flex;
    flex-direction:row;
    justify-content:space-between;
    padding: 0 5px;
    @media (max-width: 400px){
        width: 190px;
    };
`

const Tab = styled.div`
    display:flex;
    flex-direction:column;
    justify-content:space-between;
    color: #7D7B7B;
    font-size: 13px;
    text-align: center;
    @media (max-width: 543px){
        font-size: 12px;
    };
    


    span{
    margin-top: 10px;
    color:black;
    font-weight: 500;
    font-size: 16px;
    @media (max-width: 543px){
        font-size: 14px;
    };
    @media (max-width: 400px){
        font-size: 12px;
    };
    }

`

const Hr = styled.hr`
margin: 30px 0;
height: 1px;
color: #5DB0D8;
width: 100%;
// @media (max-width: 375px){
//   width: 327px;
// };
`

const TileSec = styled.div`
display:flex;
flex-direction:row;
// justify-content:space-between;
flex-wrap: wrap;
margin: 0 auto;
max-width: 100%;

@media (max-width: 543px){
      max-width: calc(165px*2);
};
@media (max-width: 450px){
      max-width: calc(157px*2);
};



// @media (max-width: 2560px){
//       width: calc(173px*12);
//     };
// @media (max-width: 2124px){
//       width: calc(173px*11);
//     };
// @media (max-width: 1951px){
//       width: calc(173px*10);
//     };
// @media (max-width: 1778px){
//       width: calc(173px*9);
//     };
// @media (max-width: 1605px){
//       width: calc(173px*8);
//     };
// @media (max-width: 1432px){
//       width: calc(173px*7);
//     };
// @media (max-width: 1259px){
//       width: calc(173px*6);
//     };
// @media (max-width: 1086px){
//       width: calc(173px*5);
//     };
// @media (max-width: 913px){
//       width: calc(173px*4);
//     };
// @media (max-width: 815px){
//       width: calc(165px*4);
//     };
// @media (max-width: 708px){
//       width: calc(165px*3);
//     };
// @media (max-width: 543px){
//       width: calc(165px*2);
//     };



// @media (max-width: 660px){
//       width: calc(165px*3);
//     };
// @media (max-width: 495px){
//       width: calc(165px*2);
//     };
// @media (max-width: 330px){
//       width: calc(157px*2);
//     };
`

const Label = styled.label`
    position: absolute;
    
`

const Div = styled.div`
    position: absolute;
    margin-top: ${props => props.count===0 ? '29.7vh' : '21.5vh'}
`


const Bottom = styled.div`
    /* border-top: 3px solid #5DB0D8; */
    min-width: 87.84vw;
    margin-left:auto;
    margin-right:auto;
    position:relative;
    margin-top: 22.83vh;
    display:flex;
    flex-wrap:wrap;
    flex-direction:row;
    justify-content:center;
    margin-top: 1.5vh;
    padding-top: 0.76vh;

    /* border:1px solid orange; */
    /* height: 292px; */
`






























// import React, { useState, useEffect } from "react";
// import styled from "styled-components";
// import NavFront from "../Front/NavFront";
// import NavFornt from "../Front/NavFront";
// //import pro from '../../../assets/z1.png'
// import Tile from "../Front/Tile";
// import FooterNew from "../../layouts/FooterNew";
// import { userContext } from "../../../App";
// import { auth, db } from "../../../firebase";
// import firebase from "../../../firebase";
// // import { useState } from "react/cjs/react.development";
// import { useHistory } from "react-router";
// import user from '../../../assets/user.png';
// import PublishIcon from '@material-ui/icons/Publish';
// import CancelIcon from '@material-ui/icons/Cancel';
// import SimpleModal from './SimpleModal';
// import ProfileTile from '../Front/ProfileTile';
// import Search from '../Front/Search'
// const User = ()=>{
//     const id=JSON.parse(localStorage.getItem("profileid"))['profileid'];
//     const uid=JSON.parse(localStorage.getItem("user"))['uid'];
//     const history = useHistory();
//     if(localStorage.getItem('allowed')==='0'){
//         window.location.href = '/home';
//     }
//     function tileclick(x){

//         localStorage.setItem(
//             "postid",
//             JSON.stringify({
//               postid:x,
             
//             })
//           );
//           history.push(`/folio/${x}`)
//     }

//     const [post, setpost] = useState([]);
//     const [name, setname] = useState();
//     async function delete_folio(z)
//     {
//         await db.collection("posts").doc(z).delete();
//     }
//     const[count,setCount]=useState(0);
//     const[read,setRead]=useState(0);
//     const[follower,setFollower]=useState(0);
//     const [allowEdit, setallowEdit] = useState(false);
//     const [removePhoto, setremovePhoto] = useState(false);
//     const [profilePhoto, setprofilePhoto] = useState(user);
//     const [publishPhoto, setpublishPhoto] = useState(false);
//     const [desc, setdesc] =useState("");
//     const [imgUrl, setimageUrl] = useState(null);
//     const[isfollow,setisfollow]=useState();
//     const[followList,setfollowlist]=useState();
//     const [searchtext, setsearchtext] = useState('');
//     const[searchtype,setsearchtype]=useState([]);
//     const [navClick, setnavClick] = useState(false);
//     const [allposts, setallposts] = useState([]);
//     const [exacttitle, setexacttitle] = useState('');
//     const [searchtitle, setsearchtitle] = useState([]);
//     const [searchClicked, setsearchClicked] = useState(false);
//     const[test,setTest]=useState(false);
//     const fetchBlogs = async () => {
//         //const id=JSON.parse(localStorage.getItem("profileid"))['profileid'];
//             console.log(id);
//       const response = db.collection("posts").where("postedBy","==",id );
//       const data = await response.onSnapshot((querySnapshot) => {
//         const arr=[];
//         var c=0;
//         var r=0;
//         querySnapshot.forEach((doc) => {
//             var data=doc.data();
//             c=c+1;
//             r=r+doc.data().read_Count;
//             data={...data,id:doc.id}
    
//             arr.push(data);
            
        
//         })
        
//         setpost(arr);
//         setCount(c);
//         setRead(r);
//       });
//         var docRef = db.collection("users").doc(id);
//         const data2 = await docRef.onSnapshot((querySnapshot) => {
//             var follow=0;var profile_pic;var name,desc;
//             follow=querySnapshot.data().follower_Count;
//             profile_pic=querySnapshot.data().profilePic;
//             name=querySnapshot.data().name;
//             desc=querySnapshot.data().description;
//            var f_arr=querySnapshot.data().follower;
//            setfollowlist(querySnapshot.data().follower);
//            if(f_arr.indexOf(uid)>-1)
//            {
//                 setisfollow(true)
//            }
//            else{
//                    setisfollow(false);
//            }
//             if(profile_pic==="")
//             {
//                     setprofilePhoto(user);
//             }
//             else{
//                 setprofilePhoto(profile_pic)
//             }
//             setFollower(follow);
//             setname(name);
//             setdesc(desc);
//         });
//     }
//     useEffect(() => {
      
      
//       fetchBlogs();
      
//     }, [id]);

//     const Tofollow=async()=>{
//         let arr=[...followList];
//         arr.push(uid);
//         await db.collection("users").doc(id).update({follower:arr});
//         await db.collection("users").doc(id).update({follower_Count:arr.length});
//         setisfollow(true);
//     }
//     const Tounfollow=async()=>{
//         let arr=[...followList];
//         arr = arr.filter(e => e !== uid);
//         await db.collection("users").doc(id).update({follower:arr});
//         await db.collection("users").doc(id).update({follower_Count:arr.length});
//         setisfollow(false);
//     }

//     const remove = () =>{
      
//         setremovePhoto(true);
//         setprofilePhoto(user);
//        // setimageCropped(false);
//         db.collection("users").doc(uid).update({profilePic:""});
//     }

//     const Edit = () =>{
//         const uid = auth.currentUser.uid;
//         setallowEdit(true);
//     }

    
    
//     const [imageCropped, setimageCropped] = useState(false);
//     const [image, setImage] = useState(null);
//     const types = ["image/png", "image/jpeg", "image/jpg"];
//     const [fileselect, setfileselect] = useState(null);

//     var getFileBlob = function (url, cb) {
//     var xhr = new XMLHttpRequest();
//     xhr.open("GET", url);
//     xhr.responseType = "blob";
//     xhr.addEventListener('load', function() {
//       cb(xhr.response);
//     });
//     xhr.send();
//   };
//     const handleChange = (e) => {
//         let selectedFile = e.target.files[0];
//         setfileselect(URL.createObjectURL(selectedFile));
//         if (selectedFile) {
//           console.log('a')
//           if (types.includes(selectedFile.type)) {
//             setImage(selectedFile);
//             // const files = firebase.storage();
//             // getFileBlob(fileselect, blob =>{
//             //     firebase.storage().ref(`/folios/${uid}`).put(blob).then(snap => {
//             //       snap.ref.getDownloadURL().then((url) => {
//             //         setimageUrl(url);
//             //         db.collection("users").doc(uid).update({profilePic:url});
//             //       });
//             //     })
//             // })
//     // files
//     //   .ref(`/users/${uid}`)
//     //   .put(selectedFile)
//     //   .then((snap) => {
//     //     console.log(snap);
//     //     snap.ref.getDownloadURL().then((url) => {
//     //      console.log(url);
//     //      db.collection("users").doc(uid).update({profilePic:url});
//     //       setimageUrl(url);
//     //     });
//     // });
//           } else {
//             console.log('b')
//             setImage(null);
//           }
//         }
//       };
//       useEffect(()=>{
//         if(!fileselect)
//           setTest(false);
//         else
//           setTest(!test);
      
//       },[fileselect])
      
//   const save=async()=>{
//     setallowEdit(false);
//     setremovePhoto(false);
//     console.log(desc);
//     console.log(name);
//     if(imageCropped){
//         const uid = auth.currentUser.uid;
//         await getFileBlob(fileselect, blob =>{
//         firebase.storage().ref(`/users/${uid}`).put(blob).then(snap => {
//             snap.ref.getDownloadURL().then((url) => {
//             setimageUrl(url);
//             db.collection("users").doc(uid).update({profilePic:url});
//             });
//         })
//         })
      
//     }
    
//     await db.collection("users").doc(uid).update({name:name});
//     await db.collection("users").doc(uid).update({description:desc});
//     const data=await db.collection("posts").where("postedBy","==",uid).get();
//  await data.docs.forEach(item=>{
//      db.collection("posts").doc(item.id).update({name:name});
//       })
   
//   }
    
//     return(
//         <>
//         <NavFront setnavClick={setnavClick} setsearchClicked={setsearchClicked} setexacttitle={setexacttitle} searchtitle={searchtitle} setsearchtitle={setsearchtitle}  searchtext={searchtext} setsearchtext={setsearchtext} setsearchtype={setsearchtype}/>
//         {!searchClicked && searchtext!=='' ? <Search exacttitle={exacttitle} searchtitle={searchtitle} setsearchClicked={setsearchClicked} searchtext={searchtext} searchtype={searchtype}/> : null}

//         <div>
//         <Detail>
//             <input
//             type="file"
//             id='input-file'
//             name="image"
//             accept="image/x-png,image/gif,image/jpeg,image/jpg"
//             onChange={handleChange}
//             style={{visibility: 'hidden', position: 'absolute'}}
//             />
//             {uid===id?
//             <SideContent>
//             {imageCropped ? <Image profilePhoto={fileselect}/> : <Image profilePhoto={profilePhoto}/>}
//                 {allowEdit ? 
//                     profilePhoto!==user ? removePhoto ? <Label fileselect={fileselect} for='input-file' style={{marginRight: '10vw'}}><PublishIcon onClick={(e) => setpublishPhoto(true)} color='primary' style={{position: 'absolute', marginLeft: '4.5vw', marginTop: '0.7vh', cursor: 'pointer'}}/></Label>
//                 : <CancelIcon color='secondary' style={{position: 'absolute', marginLeft: '4.5vw', marginTop: '0.7vh', cursor: 'pointer', marginTop: '1vh'}} onClick={remove}/> 
//                 : <Label fileselect={fileselect} for='input-file' style={{marginRight: '10vw'}}><PublishIcon onClick={(e) => setpublishPhoto(true)} color='primary' style={{position: 'absolute', marginLeft: '4.2vw', marginTop: '0.7vh', cursor: 'pointer'}}/></Label> : null}
//                 {/* <Button>Following</Button> */}
//                 {allowEdit ? <Button onClick={save}>Save</Button> : <Button onClick={Edit}>Edit</Button>}
//                 {publishPhoto & test===true ? <SimpleModal fileselect={fileselect} setfileselect={setfileselect} setimageCropped={setimageCropped} height={298} width={398} setTest={setTest}/> : null}
//             </SideContent>:<SideContent><Image profilePhoto={profilePhoto}/>{isfollow===true?<Button onClick={Tounfollow}>Following</Button>:<Button onClick={Tofollow}>Follow</Button>}</SideContent>}
//             <Bio>
//                 <Name maxLength='40' minLength='1' value={name} disabled={!allowEdit} onChange={e=>setname(e.target.value)}/>
//                 <Lines maxLength='237' minLength='1' cols='5' disabled={!allowEdit} value={desc} onChange={e=>setdesc(e.target.value)}></Lines>
//                 <Tabs>
//                     <Tab>Folios <span >{count}</span></Tab>
//                     <Tab>Reads <span >{read}</span></Tab>
//                     <Tab>Followers <span >{follower}</span></Tab>
//                 </Tabs>
//             </Bio>
//         </Detail>
//         <hr style={{
//             height:"0.45vh",
//             border:"none",
//             width: "107.4vw",
//             background:"#5DB0D8",
//         }}></hr>
//         <Bottom>
//             <div className="container">
//             <div class="row">
        
        
//             {post &&
//               post.map(p=> {
//                 return( <div className="col-xs-12 col-sm-12 col-md-6 col-lg-2">{uid===id?<ProfileTile Title={p.title} Image={p.img_url} id={p.id} onclick={tileclick} read={p.read_Count} deleted={delete_folio}/>:<Tile Title={p.title} Image={p.img_url} id={p.id}  onclick={tileclick} Name={p.name} read={p.read_Count}/>}</div>);
//               })} 
//           </div>
//             </div>
      
//         </Bottom>
//         </div>
//         <Div count={count}>
//             <FooterNew fullength={count===0 ? true : false}/>
//         </Div>
//         </>
//     )
// }

// export default User;

// const Label = styled.label`
//     position: absolute;
    
// `

// const Div = styled.div`
//     position: absolute;
//     margin-top: ${props => props.count===0 ? '29.7vh' : '21.5vh'}
// `

// const Detail = styled.div`
// position:relative;
// margin-top: 7.61vh;
// display:flex;
// justify-content:center;
// /* border:2px solid red; */
// `
// const Bottom = styled.div`
//     /* border-top: 3px solid #5DB0D8; */
//     min-width: 87.84vw;
//     margin-left:auto;
//     margin-right:auto;
//     position:relative;
//     margin-top: 22.83vh;
//     display:flex;
//     flex-wrap:wrap;
//     flex-direction:row;
//     justify-content:center;
//     margin-top: 1.5vh;
//     padding-top: 0.76vh;

//     /* border:1px solid orange; */
//     /* height: 292px; */
// `

// const Bio = styled.div`
// position: absolute;
// margin-left: 13vw;

// `
// const Tabs = styled.div`
//     display:flex;
//     flex-direction:row;
//     justify-content:space-around;
// `
// const Tab = styled.div`
//     position:relative;
//     display:flex;
//     span{
//         margin-top: 3vh; 
//     color:black;
//     font-family: Rubik;
//     font-style: normal;
//     font-weight: 500;
//     font-size: 16px;
//     line-height: 2.9vh;
//     }
    
   
//     color: #7D7B7B;
//     font-family: Rubik;
//     font-style: normal;
//     font-weight: normal;
//     font-size: 13px;
//     line-height: 2.28vh;
//     text-align: center;
    
//     flex-direction:column;
//     justify-content:space-between;
// `
// const SideContent = styled.div`
// margin-left: -27.1vw;
// padding-top: 3vh;
// padding-left: 1.46vw;
// padding-right: 1.46vw;
// /* width:200px; */
// display:flex;
// flex-direction:column;
//     /* border:1px solid green; */

// `;
// const Button = styled.button`
//  width: 10vw;
// height: 5.63vh;
// left: 33.82vw;
// top: 47.18vh;
// border:none;
// font-family: Rubik;
// font-style: normal;
// font-weight: normal;
// font-size: 19px;
// line-height: 3.5vh;
// text-align: center;
// margin-bottom: 2.43vh;

// color: #FFFFFF;


// background: #5DB0D8;
// border-radius: 16px;
// `
// const Image = styled.img.attrs(props=>({
//     src:props.profilePhoto

// }))`
    
//     width: 10vw;
// height: 20.85vh;
//    margin-bottom: 3.95vh;
// border-radius: 20px;
// `
// const Name= styled.input`
// position: absolute;
// margin-top: 3vh;
// margin-bottom: 2vh;
// width: 27.16vw;
// text-overflow: ellipsis;
// height: 3.65vh;
// font-family: Rubik;
// font-style: normal;
// font-weight: normal;
// font-size: 20px;
// line-height: 3.65vh;
// color: #000000;
// background-color:#fff;
// &:focus{
//     border: none;
//     outline: none;
// }
// &:disabled{
    
//     border: none;
// }
// &::placeholder{
//     color: black;
// }
// `
// const Lines = styled.textarea`
// resize: none;
// width: 27.16vw;
// height: 19vh;
// margin-top: 7vh;
// background-color:#fff;
// &:focus{
//     border: none;
//     outline: none;
// }
// &:disabled{
   
//     border: none;
// }
// &::placeholder{
//     color: black;
// }
// overflow: hidden;

// `